type DiamondMarkProps = {
  size?: number
  className?: string
  foreground?: string
}

export default function DiamondMark({
  size = 18,
  className,
  foreground = 'currentColor',
}: DiamondMarkProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <path d="M25 25h50l14 23H11Z" fill={foreground} />
      <path d="M11 53h78L50 89Z" fill={foreground} />
    </svg>
  )
}
